import { FormSelect, FormSelectBaseProps } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { useAppSelector } from '@/App/hooks';
import { withDisplayRule } from '@/features/displayRules/withDisplayRule';
import { selectRefDataValues } from '@/features/refdata/selectRefDataValues';
import { PageFragmentProps } from '@/features/withPageFragmentInit';

export type FormRdrSelectBaseProps = Omit<FormSelectBaseProps, 'options'> & PageFragmentProps;

const FormRdrSelectBase: React.FC<FormRdrSelectBaseProps> = (props) => {
  const { screenRef, actionRef, id } = props;
  const options = useAppSelector(selectRefDataValues(screenRef, actionRef, id));

  return <FormSelect {...props} options={options} />;
};

export const FormRdrSelect = withDisplayRule(FormRdrSelectBase);
